import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
    const subTenantId = decodedToken?.subTenantId;
    return subTenantId ? `&subTenantId=${subTenantId}` : "";
  } else if (switched && switchedSubtenant) {
    return `&subTenantId=${switchedSubtenant?.id}`;
  }
  return "";
};

const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

const WasteApi = {
  // Create product Waste Api
  CreateproductWaste: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    const headers = getHeaders();

    return apiApp.post(`/productionWaste`, jsonData, { headers })
      .then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  // List product Waste Report Api
  ListproductWasteReport: (StDate, EDate, page = 0, size = 10) => {
    //  data = getSubTenantDTO(data);
    const headers = getHeaders();

    return apiApp.get(
      `/production-wastes-report?size=${size}&page=${page}&tenantId=${decodedToken?.tenantId}&startDate=${StDate}&endDate=${EDate}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  // List product Raw Waste Report
  ListproductRawWasteReport: () => {
    // data = getSubTenantDTO(data);
    const headers = getHeaders();

    return apiApp.get(
      `/productWaste?page=0&size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  // List Storages temperatures Report Api
  ListStoragestemperatures: (StDate, EDate) => {
    //  data = getSubTenantDTO(data);
    const headers = getHeaders();

    return apiApp.get(
      `/storages/temperatures?size=100&tenantId=${decodedToken?.tenantId}&startDate=${StDate}&endDate=${EDate}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  // List product Waste Api
  ListproductWaste: () => {
    // data = getSubTenantDTO(data);
    const headers = getHeaders();

    return apiApp.get(
      `/productionWaste?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },

  // Single product Waste Api
  SingleproductWaste: (productWasteID) => {
    // data = getSubTenantDTO(data);
    const headers = getHeaders();

    return apiApp.get(
      `/productionWaste/${productWasteID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers }
    ).then(res => res.data)
      .catch(err => Promise.reject(err.response.data));
  },
};

export default WasteApi;
